<script setup lang="ts">
import { SbListItem, SbListLabel, SbListSection } from "@unio/saltbox-ui"

import { colorHex } from "@/lib/colors"
import { pluralize } from "@/lib/format"
import { ICON } from "@/lib/icons"
import { tagPath } from "@/routes"
import type { TagSummary } from "@/types/models"

defineProps<{ tag: TagSummary }>()
</script>

<template>
  <SbListItem :to="tagPath({ id: tag.id })">
    <SbListSection avatar>
      <UIcon :name="ICON.tag" class="size-5" :style="{ color: colorHex(tag.color_class) }" />
    </SbListSection>
    <SbListSection>
      <SbListLabel>{{ tag.name }}</SbListLabel>
      <SbListLabel caption>{{ pluralize(tag.usage_count ?? 0, "item") }}</SbListLabel>
    </SbListSection>
    <SbListSection side>
      <UIcon :name="ICON.chevronRight" class="size-4" />
    </SbListSection>
  </SbListItem>
</template>
